<template>
    <div class="courts-page">
        <page-hero title="Γήπεδα" eyebrow="Courts" compact />
        <div class="cl-page">
            <v-container fluid class="secondary-font px-0">
                <v-row no-gutters>
                    <v-col v-for="(arena, index) in arenas" :key="index" cols="12" md="4" class="my-3 py-3 px-2">
                        <v-card
                            class="cl-card court-card"
                            dark
                            @click="openMap(arena)"
                        >
                            <v-row class="mx-0 px-0">
                                <v-col cols="12" class="pa-0">
                                    <gmap-map
                                        :center="getMarker(arena)"
                                        :zoom="17"
                                        :options="options"
                                        style="width: 100%; height: 200px;"
                                    >
                                        <gmap-marker
                                            :position="getMarker(arena)"
                                            :clickable="true"
                                        />
                                    </gmap-map>
                                </v-col>
                            </v-row>
                            <v-row class="mx-0 px-0">
                                <v-col cols="12" class="court-card__name">
                                    <v-icon
                                        color="teal"
                                    >
                                        mdi-basketball-hoop-outline
                                    </v-icon>
                                    {{ arena.name }}
                                </v-col>
                            </v-row>
                            <v-row class="mx-0 px-0">
                                <v-col cols="12" class="court-card__address">
                                    <v-icon
                                        color="teal"
                                    >
                                        mdi-map-marker-outline
                                    </v-icon>
                                    {{ arena.address }}
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </div>
</template>

<script>
    import PageHero from '@/components/PageHero'
    import arenaService from '@/services/arena'

    export default {
        components: { PageHero },
        data() {
            return {
                center: { lat: 37.924458, lng: 23.705159 },
                options: {
                    zoomControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                    draggable: false
                },
                arenas: [],
                page: 1,
                size: 1000,
                totalPages: 1
            }
        },
        created() {
            this.fetchAllArenas()
        },
        methods: {
            openMap(arena) {
                window.open(`https://www.google.com/maps/place/${arena.coordinates}`, '_self', 'noreferrer')
            },
            fetchAllArenas() {
                arenaService.getArenas(this.page, this.size).then(resp => {
                    this.arenas = resp.data.content
                    this.totalPages = resp.data.totalPages
                })
            },
            getMarker(arena) {
                const coor = arena.coordinates.split(',')
                return { lat: Number(coor[0]), lng: Number(coor[1]) }
            }
        }
    }
</script>

<style scoped>
.court-card {
    height: 100%;
    border-top: 3px solid #03e5b7 !important;
    cursor: pointer;
}

.court-card__name {
    padding-bottom: 0;
    font-family: 'Squada One', 'Roboto Condensed', Arial, sans-serif;
    font-size: 1.5rem;
    letter-spacing: 0.02em;
}

.court-card__address {
    font-family: Roboto, Arial, sans-serif;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.7);
}
</style>
